var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D3F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.666 13.75l7.693-.625v6.25h-7.693V13.75zM20.64 13.125l7.693-.625v6.875h-7.692v-6.25zM11.666 20.625h7.693v6.25l-7.693-.625v-5.625z",
    fill: "#12D1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.64 20.625h7.693V27.5l-7.692-.625v-6.25z",
    fill: "#12D1F2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNEM0Y5RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS42NjY1IDEzLjc1TDE5LjM1ODggMTMuMTI1VjE5LjM3NUgxMS42NjY1VjEzLjc1WiIgZmlsbD0iIzEyRDFGMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwLjY0MDkgMTMuMTI1TDI4LjMzMzIgMTIuNVYxOS4zNzVIMjAuNjQwOVYxMy4xMjVaIiBmaWxsPSIjMTJEMUYyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNjY2NSAyMC42MjVIMTkuMzU4OFYyNi44NzVMMTEuNjY2NSAyNi4yNVYyMC42MjVaIiBmaWxsPSIjMTJEMUYyIi8+CjxwYXRoIGQ9Ik0yMC42NDA5IDIwLjYyNUgyOC4zMzMyVjI3LjVMMjAuNjQwOSAyNi44NzVWMjAuNjI1WiIgZmlsbD0iIzEyRDFGMiIvPgo8L3N2Zz4K";
export { SvgMicrosoft as ReactComponent };